import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import validatePermissions from "Utils/validatePermissions";

import PageHeader from "Components/Pages/Header";
import PageWrapper from "Components/Pages/Wrapper";
import { Pagination } from "Components/Pagination";
import Breadcrumb from "Components/Shared/Breadcrumb";

import { useQuery } from "react-query";
import { getUnitsList } from "../../../Requests/Units";
import { Filters } from "./components/Filters";
import { Tabledata } from "./components/Tabledata";

const initialSearchFilters = {
  name: "",
  region_id: "",
  uf: "",
  status: "",
  type: "",
};

export function Units() {
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({ orderBy: "name", orderAsc: true });
  const [searchFilters, setSearchFilters] = useState(initialSearchFilters);
  const user_permissions = useSelector((state) => state.User.permissions);

  const { data: unitsData, isLoading: isLoadingUnits } = useQuery({
    queryKey: ["units", currentPage, { ...searchFilters, ...sort }],
    queryFn: () =>
      getUnitsList({
        page: currentPage,
        filters: { ...searchFilters, ...sort },
      }),
    refetchOnWindowFocus: false,
  });

  async function handlePagination(e) {
    if (currentPage === e.currentPage) return;

    const page = e.currentPage;
    setCurrentPage(page);
  }

  const clearSearch = () => {
    setSearchFilters(initialSearchFilters);
    setCurrentPage(1);
  };

  const handleSorting = (fieldName) => {
    setSort({
      orderBy: fieldName,
      orderAsc: true,
    });
  };

  const fetchFiltersRequest = (filters) => {
    setSearchFilters(filters);
    setCurrentPage(1);
  };

  return (
    <PageWrapper className="entry-app-content order-home-list">
      <div className="content-holder">
        <div className="page-heading">
          <div className="wrapper-header-content">
            <PageHeader title="Todas as unidades">
              <Breadcrumb
                list={[
                  {
                    path: "#",
                    label: "Unidades",
                    current: false,
                  },
                  {
                    path: "#",
                    label: "Todas unidades",
                    current: true,
                  },
                ]}
              />
            </PageHeader>

            <div className="actions-holder">
              {validatePermissions("Create Units", user_permissions) && (
                <Link to="/unidades/novo" className="button _white _action">
                  Adicionar Unidade
                </Link>
              )}
            </div>
          </div>
          <Filters
            searchFilters={searchFilters}
            clearFilters={clearSearch}
            fetchFiltersRequest={fetchFiltersRequest}
          />
        </div>
        <Tabledata
          sort={sort}
          setSort={setSort}
          units={unitsData?.data.data}
          loading={isLoadingUnits}
          handleSorting={handleSorting}
        />
      </div>
      <div className="pagination-wrapper">
        {!isLoadingUnits && (
          <Pagination
            totalRecords={unitsData?.data?.last_page}
            currentPageSelected={unitsData?.data?.current_page}
            pageLimit={1}
            pageNeighbours={1}
            onPageChanged={(e) => handlePagination(e)}
          />
        )}
      </div>
    </PageWrapper>
  );
}
